class Client {
  id = '';
  lastname = '';
  firstname = '';
  fullname = '';
  gender = '';
  image = '';
  fileUrl = null;
  features = {};

  /**
   * @param data
   */
  constructor(data) {
    const properties = ['id', 'lastname', 'firstname', 'gender', 'image'];

    for (const property of properties) {
      if (typeof data[property] === 'undefined') {
        throw new Error(`Property ${property} not set`);
      }

      if (typeof data[property] !== typeof this[property]) {
        throw new Error(
          `Invalid property ${typeof data[property]} type for ${property}`
        );
      }

      this[property] = data[property];
    }

    this.fileUrl = data.fileUrl;
    this.fullname = `${data.lastname} ${data.firstname}`;

    try {
      const features = JSON.parse(data.features);

      if (typeof features === 'object') {
        for (const flag of Object.keys(features)) {
          this.features[flag] = features[flag];
        }
      }
    } catch (e) {
      // do-noting
    }
  }
}

export default Client;
